(() => {
  const W = JSON.parse(document.querySelector('[data-anya-runtime]')?.textContent || '{}');
  const builders = document.querySelectorAll('[data-pack-builder]');

  builders.forEach((builder) => {
    const offerButtons = [...builder.querySelectorAll('[data-offer]')];
    const selectorContainer = builder.querySelector('[data-scent-selectors]');
    const selectedOfferHeading = builder.querySelector('[data-selected-offer]');
    const productPrice = builder.querySelector('[data-product-price]');
    const shippingEl = builder.querySelector('[data-pack-shipping]');
    const totalPrice = builder.querySelector('[data-total-price]');
    const priceGrid = builder.querySelector('.anya-composer__price');
    const beforeLabel = builder.querySelector('[data-before-label]');
    const beforeVal = builder.querySelector('[data-before-price]');
    const savingsRow = builder.querySelector('[data-savings-row]');
    const savingsEl = builder.querySelector('[data-savings]');
    const giftLabel = builder.querySelector('[data-gift-label]');
    const giftVal = builder.querySelector('[data-gift-value]');
    const productsLabel = builder.querySelector('[data-products-label]');
    const submitButton = builder.querySelector('[data-whatsapp-submit]');
    const status = builder.querySelector('[data-status]');
    const cityInput = builder.querySelector('[data-pack-city]');
    const promoInput = builder.querySelector('[data-pack-promo]');
    const composer = builder.querySelector('.anya-composer');
    const currency = builder.dataset.currency || 'DH';
    let shippingRate = null;
    let selectedPrice = 0;
    const flatShipping = Number(builder.dataset.shippingPrice || 0);
    const freeShippingAmount = Number(builder.dataset.freeShippingAmount || 249);
    const addonFirst = Number(builder.dataset.addonFirst || 0);
    const addonNext = Number(builder.dataset.addonNext || 0);
    const addonMax = 6;
    const addonBox = builder.querySelector('[data-addon]');
    const addonContainer = builder.querySelector('[data-addon-selectors]');
    const addonCountEl = builder.querySelector('[data-addon-count]');
    const addonHelp = builder.querySelector('[data-addon-help]');
    const addonMinus = builder.querySelector('[data-addon-minus]');
    const addonPlus = builder.querySelector('[data-addon-plus]');
    // Grands pots ajoutés : seulement sur les offres d'au moins N grands (Famille), à prix fixe.
    const grandAddonPrice = Number(builder.dataset.grandAddonPrice || 0);
    const grandAddonMin = Number(builder.dataset.grandAddonMin || 0);
    const grandAddonMax = 10;
    const grandBox = builder.querySelector('[data-grand-addon]');
    const grandContainer = builder.querySelector('[data-grand-addon-selectors]');
    const grandCountEl = builder.querySelector('[data-grand-addon-count]');
    const grandHelp = builder.querySelector('[data-grand-addon-help]');
    const grandMinus = builder.querySelector('[data-grand-addon-minus]');
    const grandPlus = builder.querySelector('[data-grand-addon-plus]');
    let saved = {};
    try { saved = JSON.parse(sessionStorage.getItem('anya_selection_v2') || '{}'); } catch (e) {}
    const offerChoices = saved.choices || {};
    // Sans bloc d'ajout dans la page, aucune sélection mémorisée ne doit compter dans le prix.
    let addonCount = addonBox ? Math.min(addonMax, Math.max(0, Number(saved.addonCount || 0))) : 0;
    let addonChoices = Array.isArray(saved.addonChoices) ? saved.addonChoices : [];
    let grandCount = grandBox ? Math.min(grandAddonMax, Math.max(0, Number(saved.grandCount || 0))) : 0;
    let grandChoices = Array.isArray(saved.grandChoices) ? saved.grandChoices : [];
    const remember = () => {
      offerChoices[selectedOffer.dataset.offerId] = [...selectorContainer.querySelectorAll('select')].map(s => s.value);
      if (addonContainer) addonChoices = [...addonContainer.querySelectorAll('select')].map(s => s.value);
      if (grandContainer && grandAllowed()) grandChoices = [...grandContainer.querySelectorAll('select')].map(s => s.value);
      try { sessionStorage.setItem('anya_selection_v2', JSON.stringify({offer: selectedOffer.dataset.offerId, choices: offerChoices, city: cityInput.value, addonCount, addonChoices, grandCount, grandChoices})); } catch (e) {}
    };
    const grandAllowed = () => grandAddonPrice > 0 && grandAddonMin > 0 && Number(selectedOffer?.dataset.grandSlots || 0) >= grandAddonMin;
    const grandExtra = () => (grandAllowed() ? grandCount : 0);
    // Minis ajoutés : le premier au prix d'un mini sur une offre sans mini, les suivants au prix réduit.
    const addonPrice = () => {
      if (!addonCount) return 0;
      const hasMinis = Number(selectedOffer?.dataset.miniSlots || 0) > 0;
      return hasMinis ? addonCount * addonNext : addonFirst + (addonCount - 1) * addonNext;
    };
    const grandAddonTotal = () => grandExtra() * grandAddonPrice;
    const shippingFee = () => {
      if (!shippingRate) return null;
      if (freeShippingAmount > 0 && Math.round(selectedPrice * 100) >= Math.round(freeShippingAmount * 100)) return 0;
      return flatShipping > 0 ? flatShipping : shippingRate.price;
    };
    const fillText = (template, values) => String(template || '').replace(/\{(\w+)\}/g, (match, key) => (key in values ? values[key] : match));
    const scents = [...builder.querySelectorAll('[data-scent]')]
      .filter((item) => item.dataset.available === 'true')
      .map((item) => ({ name: item.dataset.name, label: item.dataset.label || item.dataset.name, color: item.dataset.color }));

    let selectedOffer = offerButtons.find((button) => button.classList.contains('is-selected')) || offerButtons[0];
    selectedOffer = offerButtons.find(button => button.dataset.offerId === saved.offer) || selectedOffer;
    const PT = (() => { try { return JSON.parse(builder.querySelector('[data-anya-packjs]')?.textContent || '{}'); } catch (e) { return {}; } })();

    const money = (value) => `${Number(value).toLocaleString('fr-FR')} ${currency}`;
    const getStoredPromo = () => {
      try { return localStorage.getItem('anya_referral_code') || ''; } catch (e) { return ''; }
    };
    const storePromo = (value) => {
      try {
        if (value) localStorage.setItem('anya_referral_code', value);
        else localStorage.removeItem('anya_referral_code');
      } catch (e) {}
    };
    const updateShippingSummary = () => {
      const welcome = window.AnyaWelcome.calculate(selectedPrice);
      builder.querySelectorAll('[data-welcome-label], [data-welcome-amount]').forEach(el => { el.hidden = welcome.discount <= 0; });
      const welcomeAmount = builder.querySelector('[data-welcome-amount]');
      if (welcomeAmount) welcomeAmount.textContent = '− ' + money(welcome.discount);
      const fee = shippingFee();
      if (shippingEl) shippingEl.textContent = fee === null ? (PT.shipping_pending || 'Choisissez une ville') : (fee === 0 ? (PT.shipping_free || 'Offerte') : money(fee));
      if (totalPrice) totalPrice.textContent = fee === null ? (PT.shipping_pending || 'Choisissez une ville') : money(Math.round((welcome.net + fee) * 100) / 100);
      const delay = builder.querySelector('[data-delivery-delay]');
      if (delay) delay.textContent = shippingRate ? `${PT.shipping_delay_label} : ${window.AnyaShippingRates.readableDelay(shippingRate.delay)}` : '';
      offerButtons.forEach(button => {
        const amount = window.AnyaWelcome.calculate(Number(button.dataset.price));
        button.querySelector('strong').textContent = money(amount.net);
      });
    };

    const createSelector = (label, index, isFree, format) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'anya-scent-field';

      const labelElement = document.createElement('label');
      const selectId = `${builder.id || 'anya-packs'}-scent-${index}`;
      labelElement.htmlFor = selectId;
      labelElement.textContent = isFree ? `${label} — ${PT.free_suffix || 'offert'}` : label;

      const select = document.createElement('select');
      select.id = selectId;
      select.dataset.scentChoice = '';
      select.dataset.format = format || '50 g';
      select.required = true;
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = PT.choose_scent;
      select.append(placeholder);

      scents.forEach((scent) => {
        const option = document.createElement('option');
        option.value = scent.name;
        option.textContent = scent.label;
        option.dataset.color = scent.color;
        select.appendChild(option);
      });

      wrapper.append(labelElement, select);
      select.addEventListener('change', () => { select.removeAttribute('aria-invalid'); status.textContent = ''; remember(); });
      return wrapper;
    };

    const renderAddon = () => {
      if (!addonBox || !addonContainer) return;
      addonContainer.replaceChildren();
      for (let index = 1; index <= addonCount; index += 1) {
        addonContainer.appendChild(createSelector(`${PT.addon_mini || 'Mini ajouté nº'} ${index}`, `addon-${index}`, false, '15 g'));
      }
      addonContainer.querySelectorAll('select').forEach((select, index) => { select.value = addonChoices[index] || ''; });
      if (addonCountEl) addonCountEl.textContent = String(addonCount);
      if (addonMinus) addonMinus.disabled = addonCount === 0;
      if (addonPlus) addonPlus.disabled = addonCount >= addonMax;
      const hasMinis = Number(selectedOffer?.dataset.miniSlots || 0) > 0;
      if (addonHelp) addonHelp.textContent = hasMinis
        ? fillText(PT.addon_help_next, { next: money(addonNext) })
        : fillText(PT.addon_help_first, { first: money(addonFirst), next: money(addonNext) });
    };

    const renderGrandAddon = () => {
      if (!grandBox || !grandContainer) return;
      const allowed = grandAllowed();
      grandBox.hidden = !allowed;
      grandContainer.replaceChildren();
      if (!allowed) return;
      for (let index = 1; index <= grandCount; index += 1) {
        grandContainer.appendChild(createSelector(`${PT.grand_addon_item || 'Grand ajouté nº'} ${index}`, `grand-addon-${index}`, false, '50 g'));
      }
      grandContainer.querySelectorAll('select').forEach((select, index) => { select.value = grandChoices[index] || ''; });
      if (grandCountEl) grandCountEl.textContent = String(grandCount);
      if (grandMinus) grandMinus.disabled = grandCount === 0;
      if (grandPlus) grandPlus.disabled = grandCount >= grandAddonMax;
      if (grandHelp) grandHelp.textContent = fillText(PT.grand_addon_help, { price: money(grandAddonPrice) });
    };

    const refreshPrice = () => {
      const offerPrice = Number(selectedOffer.dataset.price || 0);
      const addon = addonPrice() + grandAddonTotal();
      const price = offerPrice + addon;
      productPrice.textContent = money(price);
      selectedPrice = price;

      const refPrice = Number(selectedOffer.dataset.refPrice || offerPrice);
      const freeMiniValue = Number(selectedOffer.dataset.freeMiniValue || 0);
      const discount = Math.max(0, refPrice - freeMiniValue - offerPrice);
      const before = refPrice - freeMiniValue + addon;
      const hasDiscount = discount > 0;
      if (beforeLabel && beforeVal) { beforeLabel.hidden = beforeVal.hidden = !hasDiscount; beforeVal.textContent = money(before); }
      if (savingsRow && savingsEl) { savingsRow.hidden = savingsEl.hidden = !hasDiscount; savingsEl.textContent = `− ${money(discount)}`; }
      if (giftLabel && giftVal) { const hasGift = freeMiniValue > 0; giftLabel.hidden = giftVal.hidden = !hasGift; giftVal.textContent = money(freeMiniValue); }
      if (productsLabel && priceGrid) productsLabel.textContent = hasDiscount ? (priceGrid.dataset.labelAfter || productsLabel.textContent) : (priceGrid.dataset.labelProducts || productsLabel.textContent);
      updateShippingSummary();
    };

    const renderOffer = (offer) => {
      selectedOffer = offer;
      offerButtons.forEach((button) => {
        const selected = button === offer;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      const grandSlots = Number(offer.dataset.grandSlots || 0);
      const miniSlots = Number(offer.dataset.miniSlots || 0);
      const freeMini = offer.dataset.freeMini === 'true';
      const price = Number(offer.dataset.price || 0);

      selectedOfferHeading.textContent = offer.dataset.offerName;
      refreshPrice();
      renderAddon();
      renderGrandAddon();


      selectorContainer.replaceChildren();

      for (let index = 1; index <= grandSlots; index += 1) {
        selectorContainer.appendChild(createSelector(`${PT.grand || 'Grand 50 g nº'} ${index}`, index, false, '50 g'));
      }
      for (let index = 1; index <= miniSlots; index += 1) {
        selectorContainer.appendChild(createSelector(`${PT.mini || 'Mini 15 g nº'} ${index}`, grandSlots + index, freeMini && index === miniSlots, '15 g'));
      }
      selectorContainer.querySelectorAll('select').forEach((select,index) => { select.value = offerChoices[offer.dataset.offerId]?.[index] || ''; });

      status.textContent = scents.length ? '' : (PT.no_scents || 'Aucun parfum disponible pour le moment.');
    };

    const revealComposer = () => {
      if (!composer || !window.matchMedia('(max-width: 899px)').matches) return;
      window.requestAnimationFrame(() => composer.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    };

    const changeAddon = (delta) => {
      remember();
      addonCount = Math.min(addonMax, Math.max(0, addonCount + delta));
      renderAddon();
      refreshPrice();
      remember();
    };
    addonMinus?.addEventListener('click', () => changeAddon(-1));
    addonPlus?.addEventListener('click', () => changeAddon(1));
    const changeGrand = (delta) => {
      remember();
      grandCount = Math.min(grandAddonMax, Math.max(0, grandCount + delta));
      renderGrandAddon();
      refreshPrice();
      remember();
    };
    grandMinus?.addEventListener('click', () => changeGrand(-1));
    grandPlus?.addEventListener('click', () => changeGrand(1));

    offerButtons.forEach((button) => button.addEventListener('click', () => {
      remember();
      renderOffer(button);
      remember();
      revealComposer();
    }));

    const productSticky = document.querySelector('[data-product-sticky]');
    if (productSticky && 'IntersectionObserver' in window) {
      const composerObserver = new IntersectionObserver(([entry]) => {
        productSticky.classList.toggle('is-hidden-for-composer', entry.isIntersecting);
      }, { threshold: 0.08 });
      composerObserver.observe(builder);
    }

    window.addEventListener('anya:select-pack', (event) => {
      const detail = event.detail || {};
      const requestedOffer = detail.offerId
        ? offerButtons.find((button) => button.dataset.offerId === detail.offerId)
        : null;
      renderOffer(requestedOffer || selectedOffer);

      if (detail.scent && scents.some((scent) => scent.name === detail.scent)) {
        selectorContainer.querySelectorAll('[data-scent-choice]').forEach((select) => {
          select.value = detail.scent;
        });
      }
      if (detail.city && cityInput) {
        cityInput.value = detail.city;
        cityInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (detail.promo && promoInput) {
        promoInput.value = detail.promo;
        promoInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      status.textContent = requestedOffer
        ? `${requestedOffer.dataset.offerName}${PT.selected_suffix || ' sélectionné. Choisissez chaque parfum puis confirmez sur WhatsApp.'}`
        : (PT.status_choose || 'Choisissez l’offre qui vous convient, puis personnalisez chaque parfum.');
      revealComposer();
    });

    if (saved.city) cityInput.value = saved.city;
    window.AnyaShippingRates?.attach(cityInput, (match) => {
      shippingRate = match;
      if (match) {
        cityInput.value = match.city;
        cityInput.removeAttribute('aria-invalid');
        status.textContent = '';
      }
      updateShippingSummary();
      try { const previous=JSON.parse(sessionStorage.getItem('anya_selection_v2') || '{}'); previous.city=cityInput.value; sessionStorage.setItem('anya_selection_v2',JSON.stringify(previous)); } catch (e) {}
    }, currency, {
      priceText: flatShipping > 0 ? fillText(PT.shipping_rule, { price: money(flatShipping), amount: money(freeShippingAmount) }) : '',
      rate: PT.shipping_rate_label,
      delay: PT.shipping_delay_label,
      hint: PT.city_search_hint,
      empty: PT.city_no_results,
    });

    if (promoInput) {
      promoInput.value = promoInput.value || getStoredPromo();
      if (promoInput.value) promoInput.closest('details').open = true;
      promoInput.addEventListener('input', () => storePromo(promoInput.value.trim()));
    }

    window.addEventListener('anya:welcome-change', updateShippingSummary);

    // Panier multi-produits : mêmes contrôles de parfums, la ville et la livraison se règlent dans le panier.
    const cartButton = builder.querySelector('[data-pack-cart]');
    if (cartButton) {
      cartButton.dataset.label = cartButton.textContent;
      const resetCartButton = () => {
        if (!cartButton.classList.contains('is-added')) return;
        cartButton.classList.remove('is-added');
        cartButton.textContent = cartButton.dataset.label;
      };
      builder.addEventListener('change', resetCartButton);
      builder.addEventListener('click', (event) => {
        if (event.target.closest('[data-offer],[data-addon-plus],[data-addon-minus],[data-grand-addon-plus],[data-grand-addon-minus]')) resetCartButton();
      });
    }
    cartButton?.addEventListener('click', () => {
      if (!window.AnyaCart) return;
      const choices = [...builder.querySelectorAll('[data-scent-selectors] [data-scent-choice], [data-grand-addon-selectors] [data-scent-choice], [data-addon-selectors] [data-scent-choice]')];
      if (!choices.length) {
        status.textContent = PT.no_scents_offer || 'Cette offre ne contient encore aucun parfum disponible.';
        return;
      }
      const missing = choices.filter(select => !select.value);
      if (missing.length) {
        missing.forEach(select => select.setAttribute('aria-invalid','true'));
        status.textContent = PT.scent_required;
        missing[0].focus();
        return;
      }
      const addon = addonPrice();
      const grandAddon = grandAddonTotal();
      const offerPrice = Number(selectedOffer.dataset.price || 0);
      const refPrice = Number(selectedOffer.dataset.refPrice || offerPrice);
      status.textContent = '';
      window.AnyaCart.add({
        product: builder.dataset.productTitle,
        handle: builder.dataset.productHandle,
        offer: selectedOffer.dataset.offerName,
        lines: [
          ...choices.map(select => `${select.dataset.format === '15 g' ? W.size_15 : W.size_50} — ${(select.selectedOptions[0]?.textContent || select.value || '').trim()}`),
        ],
        price: offerPrice + addon + grandAddon,
        reference: refPrice + addon + grandAddon,
        url: window.location.pathname,
      });
      cartButton.classList.add('is-added');
      cartButton.textContent = window.AnyaCart.labels.added;
    });

    submitButton.addEventListener('click', () => {
      const phone = (builder.dataset.whatsappNumber || '').replace(/\D/g, '');
      if (!phone) {
        status.textContent = PT.no_phone || 'Le numéro WhatsApp doit être renseigné dans les réglages du thème.';
        return;
      }

      const choices = [...builder.querySelectorAll('[data-scent-selectors] [data-scent-choice], [data-grand-addon-selectors] [data-scent-choice], [data-addon-selectors] [data-scent-choice]')];
      if (!choices.length) {
        status.textContent = PT.no_scents_offer || 'Cette offre ne contient encore aucun parfum disponible.';
        return;
      }
      const missing = choices.filter(select => !select.value);
      if (missing.length) {
        missing.forEach(select => select.setAttribute('aria-invalid','true'));
        status.textContent = PT.scent_required;
        missing[0].focus();
        return;
      }

      const addon = addonPrice();
      const grandAddon = grandAddonTotal();
      const price = Number(selectedOffer.dataset.price || 0) + addon + grandAddon;
      const city = String(cityInput?.value || '').trim();
      const delivery = window.AnyaShippingRates?.lookup(city);
      if (!delivery) {
        cityInput?.setAttribute('aria-invalid', 'true');
        status.textContent = PT.city_required || 'Choisissez une ville proposée dans la liste pour calculer la livraison.';
        cityInput?.focus();
        return;
      }
      shippingRate = delivery;
      const fee = shippingFee();
      const welcome = window.AnyaWelcome.calculate(price);
      const offerPrice = Number(selectedOffer.dataset.price || 0);
      const refPrice = Number(selectedOffer.dataset.refPrice || offerPrice);
      const savings = Math.max(0, refPrice - offerPrice);
      const promo = String(promoInput?.value || getStoredPromo()).trim();
      const selectionLines = choices.map(
        (select, index) => `${index + 1}. ${select.dataset.format === '15 g' ? W.size_15 : W.size_50} — ${(select.selectedOptions[0]?.textContent || select.value || '').trim()}`,
      );
      const message = [
        W.greeting,
        '',
        W.intent,
        `${W.offer} : ${selectedOffer.dataset.offerName}`,
        ...selectionLines,
        ...(selectedOffer.dataset.spatulaText ? [selectedOffer.dataset.spatulaText] : []),
        `${W.city} : ${delivery.city}`,
        '',
        ...(grandExtra() ? [`${PT.grand_addon_line || 'Grands ajoutés'} : ${grandExtra()} (${money(grandAddon)})`] : []),
        ...(addonCount ? [`${PT.addon_line || 'Minis ajoutés'} : ${addonCount} (${money(addon)})`] : []),
        `${W.products} : ${money(price)}`,
        ...(savings > 0 ? [`${PT.economy || 'Économie'} : ${money(savings)}`] : []),
        ...window.AnyaWelcome.lines(price, currency),
        `${W.shipping} : ${fee === 0 ? (PT.shipping_free || 'Offerte') : money(fee)}`,
        `${window.AnyaWelcome.totalLabel} : ${money(Math.round((welcome.net + fee) * 100) / 100)}`,
        ...(promo ? [`${PT.promo_message_label || W.promo || 'Code promo / parrainage'} : ${promo}`, PT.promo_message_note || 'À vérifier et appliquer par un agent ANYA. avant la confirmation.'] : []),
        '',
        W.confirm,
      ].join('\n');

      status.textContent = '';
      // Mesure : événement client Shopify, relayé vers les outils publicitaires par un pixel personnalisé.
      window.Shopify?.analytics?.publish?.('anya_whatsapp_order', {
        offer_id: selectedOffer.dataset.offerId,
        offer_name: selectedOffer.dataset.offerName,
        scents: choices.map((select) => `${select.dataset.format || '50 g'} — ${select.value}`),
        grands_added: grandExtra(),
        minis_added: addonCount,
        city: delivery.city,
        products_value: price,
        discount: welcome.discount,
        shipping: fee,
        value: Math.round((welcome.net + fee) * 100) / 100,
        currency: window.Shopify?.currency?.active || 'MAD',
        promo_code: promo,
        language: document.documentElement.lang,
        page: window.location.pathname,
      });
      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');

    });

    renderOffer(selectedOffer);
  });
})();
